import Vue from "vue";

Vue.component("entity-management", {
    props: ["entities", "party", "modificationModel"],
    data() {
        return {
            annexId: 0,
            loading: false,
            selectedId: '0|0',
            revisionModel: this.modificationModel,
            contextId: '0|0|0',
            partyCode: this.party
        };
    },
    watch: {
        selectedId: function (selected) {
            const self = this;

            if (selected != null && selected != undefined && selected != '0|0') {
                const splitted = selected.split('|');
                if (splitted != null && splitted[0] != null) {
                    /*self.$refs.metadataEditor.initialize(splitted[0]);*/
                    /*<entity-metadata-editor ref="metadataEditor" :contextId.sync="contextId"></entity-metadata-editor>*/
                    self.$refs.fieldEditor.initialize(splitted[0]);
                }
            }                        
        },
        contextId: function (context) {
            const self = this;

            if (context != null && context != undefined && context != '0|0|0') {
                const splitted = context.split('|');
                if (splitted != null && splitted[0] != null && splitted[1] != null) {
                    console.log(splitted[1]);

                    if (splitted[1] == '0') {
                        self.$refs.fieldEditor.initialize(splitted[0]);
                    }
                    else {
                        self.revisionModel.updatedEntityCount += 1;
                        self.$emit('update:modificationModel', self.revisionModel);
                    }
                }
            }
        }
    },
    template: `
		<div class="annex-entities">
			<template v-if="loading"><loading></loading></template>
			<template v-else>				
				<entity-treeview-management :data="entities" :selected.sync="selectedId"></entity-treeview-management>												
			</template>                                    
            <entity-basic-info-editor ref="fieldEditor" :useModal="true" :annexId="annexId" :party="partyCode" :contextId.sync="contextId"></entity-basic-info-editor>
		</div>
	`
});